import MuiTab from '@mui/material/Tab';
import MuiTabs from '@mui/material/Tabs';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { QueryNavLink } from 'shared/lib/react-router-dom';
import { mobileTodoNavigation } from 'shared/routes/navigation';
import { Paths } from 'shared/routes/paths';
import { useTheme } from 'styled-components';

export type MobileTodoNavigationProps = {
  activePath: Paths;
};

export const MobileTodoNavigation: React.FC<MobileTodoNavigationProps> = ({
  activePath,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const activeIndex = useMemo(
    () =>
      activePath
        ? mobileTodoNavigation?.findIndex(({ pathsToMatch }) =>
            pathsToMatch?.includes(activePath),
          )
        : undefined,
    [activePath],
  );
  return (
    theme.isMobile && (
      <MuiTabs value={activeIndex} variant="scrollable" scrollButtons={false}>
        {mobileTodoNavigation.map((navigationItem) => (
          <MuiTab
            key={navigationItem.id}
            component={QueryNavLink}
            to={navigationItem.link!}
            label={t(navigationItem.translationLabel)}
            replace
            disableRipple
          />
        ))}
      </MuiTabs>
    )
  );
};
